// ── API Endpoints (SANS préfixe /api — le client axios l'ajoute) ──
// Centralise les endpoints du module home-dashboard.

export const API_ENDPOINTS = {
  DASHBOARD_CONGE: "/dashboard/conges",
  DASHBOARD_SUMMARY: "/dashboard/summary",
  DASHBOARD_POINTAGE: "/dashboard/pointage",

  // ── Notes de frais ──
  FRAIS_DASHBOARD: "/frais/me",

  // ── Ressources partagées (hors module home-dashboard) ──
  CONTRATS: {
    ME: "/contrats/me",
  },
} as const;
